// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"home_text-gradient__rm5Ez","rainbow-border":"home_rainbow-border__t63bD","rotate":"home_rotate__xz3yf"};